import ProtectedRoute from '@/components/common/ProtectedRoute'; // Import ProtectedRoute
import { AppRouteConfig } from '@/types/routes';
import { LogIn } from 'lucide-react'; // Assuming this was used for an icon
import { lazy } from 'react';
import { createRoute } from './utils';

// Assume AuthLayout and PublicOnlyRoute were handled higher up or implicitly

// Lazy load auth page components (Using original paths based on context)
const Login = lazy(() => import('@/pages/auth/Login'));
const ForgotPassword = lazy(() => import('@/pages/auth/ForgotPassword'));
const ResetPassword = lazy(() => import('@/pages/auth/ResetPassword'));
const RegisterPage = lazy(() => import('@/pages/RegisterPage')); // Using the path we created
const OnboardingPage = lazy(() => import('@/pages/OnboardingPage')); // Lazy load OnboardingPage
const SlackOAuthCallback = lazy(() => import('@/pages/oauth/SlackOAuthCallback')); // Lazy load SlackOAuthCallback
const MCPOAuthCallback = lazy(() => import('@/pages/oauth/MCPOAuthCallback')); // Lazy load MCPOAuthCallback

// Auth routes configuration
export const authRoutes: AppRouteConfig[] = [
  // Assuming createRoute adds necessary wrappers like PublicOnlyRoute if needed
  createRoute('/login', <Login />, 'Login', LogIn), // Original login route
  createRoute('/register', <RegisterPage />, 'Register'), // Added register route
  createRoute('/forgot-password', <ForgotPassword />, 'Forgot Password'), // Original forgot password
  createRoute('/reset-password', <ResetPassword />, 'Reset Password'), // Original reset password
  // Onboarding route - Protected route structure
  {
    path: '/onboarding',
    element: <ProtectedRoute />, // Use ProtectedRoute as the element
    children: [
      // Nest the actual page component inside children
      {
        index: true, // Or path: '' if it's the only child
        element: <OnboardingPage />,
      },
    ],
    // Removed meta property
  },
  // Slack OAuth callback route - Protected route structure
  {
    path: '/oauth/slack/callback',
    element: <ProtectedRoute />, // Use ProtectedRoute as the element
    children: [
      {
        index: true,
        element: <SlackOAuthCallback />,
      },
    ],
  },
  // MCP OAuth callback route - Protected route structure
  {
    path: '/oauth/mcp/:serverId/callback',
    element: <ProtectedRoute />, // Use ProtectedRoute as the element
    children: [
      {
        index: true,
        element: <MCPOAuthCallback />,
      },
    ],
  },
];
